import { inject, Injectable, signal, PLATFORM_ID, makeStateKey, TransferState } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { filter } from "rxjs/operators";
import { isPlatformBrowser } from "@angular/common";

const IS_STATIC_PAGE_KEY = makeStateKey<boolean>('isStaticPage');

@Injectable({
  providedIn: 'root',
})
export class StaticPagesService {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly transferState = inject(TransferState);
  private readonly platformId = inject(PLATFORM_ID);
  public readonly isStaticPage = signal(false);

  constructor() {
    // Try to get the state from TransferState (from SSR)
    const cachedState = this.transferState.get(IS_STATIC_PAGE_KEY, null);

    if (cachedState !== null) {
      // Use cached value from server
      this.isStaticPage.set(cachedState);
    } else {
      // Initialize on first load (server side)
      this.updateStaticPageState();
    }

    // Update on navigation changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateStaticPageState();
      });
  }

  private updateStaticPageState(): void {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const isStatic = route.snapshot.data['isStatic'] === true;
    this.isStaticPage.set(isStatic);

    // Store in TransferState for client hydration
    if (!isPlatformBrowser(this.platformId)) {
      this.transferState.set(IS_STATIC_PAGE_KEY, isStatic);
    }
  }
}
